import { enqueueFieldSave, runWriteThenRefresh } from './fieldSaveQueue';

export function enqueueProfileFieldSave(queueRef, {
    userId,
    field,
    value,
    updateProfile,
    refreshProfile,
    onError,
    onWriteSuccess,
    onRefreshError,
    timeoutMs,
} = {}) {
    if (!queueRef || typeof queueRef !== 'object') {
        return Promise.reject(new Error('Cannot save profile field without a queue.'));
    }
    if (!userId || !field) {
        return Promise.reject(new Error('Cannot save profile field without an authenticated user.'));
    }
    if (typeof updateProfile !== 'function') {
        return Promise.reject(new Error('Cannot save profile field without an update function.'));
    }

    const context = { userId, field };
    const successContext = { ...context, value };
    return enqueueFieldSave(queueRef, ({ signal } = {}) => runWriteThenRefresh({
        write: ({ signal: writeSignal } = {}) => updateProfile(userId, {
            profile: { [field]: value ?? '' },
        }, { signal: writeSignal }),
        onWriteSuccess: (result) => onWriteSuccess?.(result, successContext),
        refresh: ({ signal: refreshSignal } = {}) => refreshProfile?.({ signal: refreshSignal }),
        onWriteError: (error) => onError?.(error, context),
        onRefreshError: (error) => onRefreshError?.(error, context),
        signal,
    }), { timeoutMs });
}
